<template>
  <div style="display: contents">
    <Error
      v-if="siteStructureNotFound"
      :error="err"
    />
    <Default v-else>
      <Error :error="err" />
    </Default>
  </div>
</template>

<script>
import Default from './layouts/default.vue';
import Error from './components/pages/Error.vue';

const SITE_STRUCTURE_ERROR_TEXT = '(Site Structure not found)';

export default {
  components: {
    Default,
    Error,
  },
  props: {
    error: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    siteStructureNotFound() {
      const msg = typeof this.error.message === 'string' ? this.error.message : '';
      return msg.includes(SITE_STRUCTURE_ERROR_TEXT);
    },
    err() {
      const error = { ...this.error };
      if (this.siteStructureNotFound) {
        error.message = (typeof error.message === 'string' ? error.message : '').replace(SITE_STRUCTURE_ERROR_TEXT, '');
      }
      return error;
    },
  },
};
</script>
